export const POPOVER_GHOST_ANCHOR_ATTRIBUTE = 'data-wf-popover-ghost-anchor';
export const POPOVER_GHOST_SOURCED_ATTRIBUTE = 'data-wf-popover-ghost-sourced';
